import { lazy } from "react";
import { Navigate } from "react-router-dom";
import RedirectToBudgetIfLoggedIn from "../../utils/RedirectToBudgetIfLoggedIn";
import ProtectedRoute from "../guards/ProtectedRoute";

const AuthenticationLayout = lazy(() =>
  import("../../layouts/authentication/AuthenticationLayout")
);
const ActionHandler = lazy(() =>
  import("../../Modules/Authentication/Components/ActionHandler")
);
const AuthenticationCard = lazy(() =>
  import("../../Modules/Authentication/Components/AuthenticationCard")
);
const LandingPage = lazy(() => import("../../pages/LandingPage/LandingPage"));
const GetStartedPage = lazy(() =>
  import("../../pages/GetStarted/GetStartedPage")
);
const TermsPage = lazy(() => import("../../pages/Legal/TermsPage"));
const PrivacyPage = lazy(() => import("../../pages/Legal/PrivacyPage"));
const publicRoutes = [
  /* ------------------------------ Login ------------------------------ */
  {
    path: "/",
    element: <RedirectToBudgetIfLoggedIn />,
  },

  /* ----------------------------- Landing ----------------------------- */
  {
    path: "/home",
    element: <LandingPage />,
  },
  {
    path: "/get-started",
    element: (
      <ProtectedRoute>
        <GetStartedPage />
      </ProtectedRoute>
    ),
  },
  {
    // Legacy: keep /workspaces/new working for any existing bookmarks/links
    path: "/workspaces/new",
    element: <Navigate to="/get-started" replace />,
  },

  /* --------------------------- Legal pages --------------------------- */
  { path: "/terms", element: <TermsPage /> },
  { path: "/privacy", element: <PrivacyPage /> },

  /* --------------------------- Auth Redirect --------------------------- */
  {
    path: "/sign-in",
    element: <RedirectToBudgetIfLoggedIn />,
  },
  {
    path: "/login",
    element: <Navigate to="/sign-in" replace />,
  },

  /* --------------------------- Authentication -------------------------- */
  {
    path: "/",
    element: <AuthenticationLayout />,
    children: [
      { path: "sign-up", element: <AuthenticationCard /> },
      { path: "forgot-password", element: <AuthenticationCard /> },
      { path: "auth/*", element: <ActionHandler /> },
    ],
  },
];

export default publicRoutes;
